import React, { useEffect, createElement } from 'react';
import { IntlProvider } from 'react-intl';

import { LocaleMessages, SupportedLocale } from './locales';

export const defaultLocale = 'en-US';

function setDocumentLocale(locale: SupportedLocale) {
  document.documentElement.lang = locale;
}

export const ReactIntlProvider: React.FC<
  Omit<React.ComponentProps<typeof IntlProvider>, 'messages' | 'defaultLocale'> & {
    messages: LocaleMessages;
    locale: SupportedLocale;
  }
> = ({ messages, locale, ...props }) => {
  useEffect(() => {
    // Set the document locale/langauge...
    setDocumentLocale(locale);
  }, [locale]);

  return createElement(IntlProvider, {
    ...props,
    messages,
    defaultLocale,
    locale,
  });
};
